import { BILLING_TARIFF_ALIAS, BILLING_TARIFF_PERIOD } from '@/features/billing/consts/tariff'
import { Tariff } from '@/features/billing/types'

const { FREE, TEST, STATICA, PREMIUM } = BILLING_TARIFF_ALIAS
const { MONTHLY, ANNUALLY } = BILLING_TARIFF_PERIOD

export const isFree = (alias: BILLING_TARIFF_ALIAS): boolean => {
  return alias === FREE
}

export const isPremium = (alias: BILLING_TARIFF_ALIAS): boolean => {
  return alias === PREMIUM
}

export const isStatica = (alias: BILLING_TARIFF_ALIAS): boolean => {
  return alias === STATICA
}

export const isTest = (alias: BILLING_TARIFF_ALIAS): boolean => {
  return alias === TEST
}

export const compareTariffLevel = (target: Tariff, tariff: Tariff) => {
  let result = {
    isDowngrade: false,
    isUpgrade: false,
  }

  if (!tariff) {
    result = {
      ...result,
      isUpgrade: true,
    }

    return result
  }

  if (tariff?.id === target?.id) {
    return result
  }

  // if is upgrade
  if (
    (tariff.period === MONTHLY && target.period === ANNUALLY) ||
    (tariff.period === target.period &&
      [FREE, TEST].includes(tariff.alias) &&
      ![FREE, TEST].includes(target.alias))
  ) {
    result = {
      isDowngrade: false,
      isUpgrade: true,
    }
  } else {
    // is downgrade
    result = {
      isDowngrade: true,
      isUpgrade: false,
    }
  }

  return result
}

export const isDowngradeTariffLevel = (target: Tariff, tariff: Tariff): boolean => {
  return compareTariffLevel(target, tariff)?.isDowngrade
}
